import { Card, cn } from '@design-system';
import { SlideOutSheet } from '@client/components';
import { BsFillQuestionCircleFill } from 'react-icons/bs';

import type { ReactNode } from 'react';

interface AnimatedDataPopupProps {
  label: string;
  value: string | number;
  unit?: string;
  delay?: number;
  className?: string;
  slideOutContent?: ReactNode;
  badge?: ReactNode;
}

export function AnimatedDataPopup({
  label,
  value,
  unit,
  delay = 0,
  className,
  slideOutContent,
  badge,
}: AnimatedDataPopupProps) {
  return (
    <Card
      className={cn(
        'animate-spring-in backface-hidden min-w-44 transform-gpu gap-1 rounded-lg p-4 text-center',
        className,
      )}
      style={{
        animationDelay: `${delay}ms`,
        animationFillMode: 'backwards',
      }}
    >
      <p className="text-muted-foreground text-xs font-medium uppercase tracking-wider">
        {label}
        {slideOutContent && (
          <SlideOutSheet
            slideOutContent={<>{slideOutContent}</>}
            title="AI"
          >
            <BsFillQuestionCircleFill
              className="text-muted-foreground hover:text-foreground ml-1 inline-block size-3.5 align-middle"
              aria-hidden="true"
            />
          </SlideOutSheet>
        )}
      </p>
      <p className="text-primary mt-1 flex items-center justify-center gap-1.5 text-2xl font-bold">
        {value}
        {unit && <span className="text-muted-foreground text-sm font-medium">{unit}</span>}
        {badge}
      </p>
    </Card>
  );
}
